import React, { Component } from "react"
import { Route, Switch, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { NotificationManage } from "./components/NotificationManage"
import * as Page from "./Loadable/LoadAblePage"
import * as user_actions from "./actions/action_user"
import { sizeofwindows } from "./containers/Function/App.function"

class CustomRoute extends Component {
	constructor(props) {
		super(props)
		this.state = {
			hideNav: false
		}
	}
	componentDidMount() {
		window.addEventListener("resize", this.resize.bind(this))
		this.resize()
		try {
			if (localStorage.getItem("LinkedIn") === "true") {
				localStorage.clear()
				localStorage.setItem("UsedCookie", "true")
				localStorage.setItem("Language", "en")
			}
		} catch (error) {}

		this.props
			.restoreSession()
			.then(async (res) => {
				await this.props.get_user(
					res.value.result.Credentials.data.IdentityId,
					this.props.user
				)
			})
			.catch((whyFailed) => {
				if (whyFailed.message && whyFailed.message !== "No session found") {
					NotificationManage(
						"warning",
						`Could not restore your session! Please login again.`,
						`Failure`
					)
				}
			})
		this.props.userobject()
	}
	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0)
		}
	}
	resize() {
		this.setState({ hideNav: sizeofwindows("md") })
	}
	render() {
		const { hideNav } = this.state
		const { user, userInfo } = this.props
		return hideNav ? (
			Object.keys(user).length === 0 ? (
				<Switch>
					<Route exact path="/" component={Page.Home} />
					<Route exact path="/Features" component={Page.Features} />
					<Route exact path="/Services" component={Page.Services} />
					<Route exact path="/EditYourProfile" component={Page.Home} />
					<Route exact path="/UserProfile" component={Page.Home} />
					<Route exact path="/UserProfile/:userId" component={Page.Home} />
					<Route exact path="/Signin" component={Page.MLogin} />
					<Route exact path="/Signup" component={Page.MRegister} />
					<Route exact path="/Repassword" component={Page.MRepassword} />
					<Route exact path="/Contactus" component={Page.Home} />
					<Route exact path="/GlobalProjects" component={Page.GlobalProjects} />
					<Route exact path="/MyProjects" component={Page.Home} />
					<Route exact path="/Community" component={Page.Community} />
					<Route exact path="/callback" component={Page.CallBack} />
					<Route exact path="/Tutorial" component={Page.Tutorial} />
					<Route exact path="/Project/:projectId" component={Page.Home} />
					<Route exact path="/AdvancedSearch" component={Page.AdvancedSearch} />
					<Route exact path="/Document/:Header/:id" component={Page.Document} />
					<Route exact path="/AddYourScript/:projectId" component={Page.Home} />
					<Route exact path="/Blogs/:head" component={Page.Home} />
					<Route exact path="/Blogs" component={Page.Home} />
					<Route
						exact
						path="/EditYourScript/:projectId/:assignmentId"
						component={Page.Home}
					/>
					<Route
						exact
						path="/TermsandPrivacypolicy"
						component={Page.TermsPrivacypolicy}
					/>
					<Route
						exact
						path="/Tutorial/:Header/:Vid"
						component={Page.VideoDetail}
					/>
					<Route
						exact
						path="/ProjectOverviews/:Keyword/:Source/:ResearchArea/:projectId"
						component={Page.ProjectOverviews}
					/>
					<Route
						exact
						path="/ProjectOverviews/:Keyword/:ResearchArea/:projectId"
						component={Page.ProjectOverviews}
					/>
					<Route
						exact
						path="/ProjectOverview/:Keyword/:Source/:ResearchArea/:projectId"
						component={Page.ProjectOverview}
					/>
					<Route
						exact
						path="/ProjectOverview/:Keyword/:ResearchArea/:projectId"
						component={Page.ProjectOverview}
					/>
					<Route
						exact
						path="/ForgotPassword"
						component={Page.MForgotPassword}
					/>
					<Route
						exact
						path="/ConfirmRegistration"
						component={Page.MConfirmRegistration}
					/>
					<Route
						exact
						path="/Restorepassword"
						component={Page.MRestorepassword}
					/>
					<Route exact path="/signup_success" component={Page.ThankyouSignup} />
					<Route exact path="/Notfound" component={Page.Notfound} />
					<Route component={Page.Notfound} />
				</Switch>
			) : (
				<Switch>
					<Route exact path="/" component={Page.Home} />
					<Route exact path="/Signin" component={Page.Home} />
					<Route exact path="/Signup" component={Page.Home} />
					<Route exact path="/Repassword" component={Page.Home} />
					<Route exact path="/Features" component={Page.Features} />
					<Route exact path="/Services" component={Page.Services} />
					<Route exact path="/Contactus" component={Page.MContactus} />
					<Route exact path="/GlobalProjects" component={Page.GlobalProjects} />
					<Route exact path="/MyProjects" component={Page.MyProjects} />
					<Route exact path="/Community" component={Page.Community} />
					<Route exact path="/callback" component={Page.CallBack} />
					<Route exact path="/Tutorial" component={Page.Tutorial} />
					<Route exact path="/Restorename" component={Page.MRestorename} />
					<Route exact path="/UserProfile" component={Page.UserProfile} />
					<Route exact path="/CreateModel/:projectId" component={Page.Home} />
					<Route exact path="/AddYourScript/:projectId" component={Page.Home} />
					<Route exact path="/Project/:projectId" component={Page.Home} />
					<Route exact path="/AdvancedSearch" component={Page.AdvancedSearch} />
					<Route exact path="/Document/:Header/:id" component={Page.Document} />
					<Route exact path="/Blogs/:head" component={Page.Home} />
					<Route exact path="/Blogs" component={Page.Home} />
					<Route
						exact
						path="/EditYourScript/:projectId/:assignmentId"
						component={Page.Home}
					/>
					<Route
						exact
						path="/TermsandPrivacypolicy"
						component={Page.TermsPrivacypolicy}
					/>
					<Route
						exact
						path="/Tutorial/:Header/:Vid"
						component={Page.VideoDetail}
					/>
					<Route
						exact
						path="/ProjectOverviews/:Keyword/:Source/:ResearchArea/:projectId"
						component={Page.ProjectOverviews}
					/>
					<Route
						exact
						path="/ProjectOverviews/:Keyword/:ResearchArea/:projectId"
						component={Page.ProjectOverviews}
					/>
					<Route
						exact
						path="/ProjectOverview/:Keyword/:Source/:ResearchArea/:projectId"
						component={Page.ProjectOverview}
					/>
					<Route
						exact
						path="/ProjectOverview/:Keyword/:ResearchArea/:projectId"
						component={Page.ProjectOverview}
					/>
					<Route
						exact
						path="/EditYourProfile"
						component={
							userInfo.provider === "EMAIL" ? Page.EditYourProfile : Page.Home
						}
					/>
					<Route
						exact
						path="/UserProfile/:userId"
						component={Page.UserProfile}
					/>
					<Route
						exact
						path="/EditModel/:projectId/:assignmentId"
						component={Page.Home}
					/>
					<Route exact path="/signup_success" component={Page.ThankyouSignup} />
					<Route exact path="/Notfound" component={Page.Notfound} />
					<Route component={Page.Notfound} />
				</Switch>
			)
		) : Object.keys(user).length === 0 ? (
			<Switch>
				<Route exact path="/" component={Page.Home} />
				<Route exact path="/Features" component={Page.Features} />
				<Route exact path="/Services" component={Page.Services} />
				<Route exact path="/Community" component={Page.Community} />
				<Route exact path="/GlobalProjects" component={Page.GlobalProjects} />
				<Route exact path="/MyProjects" component={Page.Home} />
				<Route exact path="/EditYourProfile" component={Page.Home} />
				<Route exact path="/Project" component={Page.Home} />
				<Route exact path="/UserProfile" component={Page.Home} />
				<Route exact path="/UserProfile/:userId" component={Page.Home} />
				<Route exact path="/CreateModel/:projectId" component={Page.Home} />
				<Route exact path="/callback" component={Page.CallBack} />
				<Route exact path="/Project/:projectId" component={Page.Home} />
				<Route exact path="/Tutorial" component={Page.Tutorial} />
				<Route exact path="/AddYourScript/:projectId" component={Page.Home} />
				<Route exact path="/AdvancedSearch" component={Page.AdvancedSearch} />
				<Route exact path="/Document/:Header/:id" component={Page.Document} />
				<Route exact path="/Blogs/:head" component={Page.Home} />
				<Route exact path="/Blogs" component={Page.Home} />
				<Route
					exact
					path="/EditYourScript/:projectId/:assignmentId"
					component={Page.Home}
				/>
				<Route
					exact
					path="/TermsandPrivacypolicy"
					component={Page.TermsPrivacypolicy}
				/>
				<Route
					exact
					path="/Tutorial/:Header/:Vid"
					component={Page.VideoDetail}
				/>
				<Route
					exact
					path="/ProjectOverviews/:Keyword/:Source/:ResearchArea/:projectId"
					component={Page.ProjectOverviews}
				/>
				<Route
					exact
					path="/ProjectOverviews/:Keyword/:ResearchArea/:projectId"
					component={Page.ProjectOverviews}
				/>
				<Route
					exact
					path="/ProjectOverview/:Keyword/:Source/:ResearchArea/:projectId"
					component={Page.ProjectOverview}
				/>
				<Route
					exact
					path="/ProjectOverview/:Keyword/:ResearchArea/:projectId"
					component={Page.ProjectOverview}
				/>
				<Route
					exact
					path="/ModelOverview/:projectId/:assignmentId"
					component={Page.Home}
				/>
				<Route
					exact
					path="/EditModel/:projectId/:assignmentId"
					component={Page.Home}
				/>
				<Route exact path="/signup_success" component={Page.ThankyouSignup} />
				<Route exact path="/Notfound" component={Page.Notfound} />
				<Route component={Page.Notfound} />
			</Switch>
		) : (
			<Switch>
				<Route exact path="/" component={Page.Home} />
				<Route exact path="/Features" component={Page.Features} />
				<Route exact path="/Services" component={Page.Services} />
				<Route exact path="/Community" component={Page.Community} />
				<Route exact path="/GlobalProjects" component={Page.GlobalProjects} />
				<Route exact path="/MyProjects" component={Page.MyProjects} />
				<Route exact path="/callback" component={Page.CallBack} />
				<Route exact path="/Project" component={Page.CreateProject} />
				<Route exact path="/UserProfile" component={Page.UserProfile} />
				<Route exact path="/UserProfile/:userId" component={Page.UserProfile} />
				<Route exact path="/Tutorial" component={Page.Tutorial} />
				<Route exact path="/AdvancedSearch" component={Page.AdvancedSearch} />
				<Route exact path="/Document/:Header/:id" component={Page.Document} />
				<Route exact path="/Blogs/:head" component={Page.Home} />
				<Route exact path="/Blogs" component={Page.Home} />
				<Route
					exact
					path="/CreateModel/:projectId"
					component={Page.CreateModel}
				/>
				<Route
					exact
					path="/AddYourScript/:projectId"
					component={Page.AddScript}
				/>
				<Route
					exact
					path="/TermsandPrivacypolicy"
					component={Page.TermsPrivacypolicy}
				/>
				<Route
					exact
					path="/Tutorial/:Header/:Vid"
					component={Page.VideoDetail}
				/>
				<Route
					exact
					path="/EditYourProfile"
					component={
						userInfo.provider === "EMAIL" ? Page.EditYourProfile : Page.Home
					}
				/>
				<Route
					exact
					path="/ProjectOverviews/:Keyword/:Source/:ResearchArea/:projectId"
					component={Page.ProjectOverviews}
				/>
				<Route
					exact
					path="/ProjectOverviews/:Keyword/:ResearchArea/:projectId"
					component={Page.ProjectOverviews}
				/>
				<Route
					exact
					path="/ProjectOverview/:Keyword/:Source/:ResearchArea/:projectId"
					component={Page.ProjectOverview}
				/>
				<Route
					exact
					path="/ProjectOverview/:Keyword/:ResearchArea/:projectId"
					component={Page.ProjectOverview}
				/>
				<Route
					exact
					path="/Project/:projectId"
					component={Page.CreateProject}
				/>
				<Route
					exact
					path="/ModelOverview/:projectId/:assignmentId"
					component={Page.ModelOverview}
				/>
				<Route
					exact
					path="/EditModel/:projectId/:assignmentId"
					component={Page.CreateModel}
				/>
				<Route
					exact
					path="/EditYourScript/:projectId/:assignmentId"
					component={Page.AddScript}
				/>
				<Route exact path="/signup_success" component={Page.ThankyouSignup} />
				<Route exact path="/Notfound" component={Page.Notfound} />
				<Route component={Page.Notfound} />
			</Switch>
		)
	}
}
const mapStateToProps = (reduxState) => {
	return {
		user: reduxState.UserReducer.user,
		userInfo: reduxState.UserReducer.userInfo
	}
}
const mapDispatchToProps = function (dispatch) {
	return {
		restoreSession: () => dispatch(user_actions.restoreSession()),
		userobject: () => dispatch(user_actions.userobject()),
		get_user: (user_id, user) => dispatch(user_actions.get_user(user_id, user))
	}
}
export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(CustomRoute)
)
